<template>
  <v-container fluid>
    <patient-header />
    <AppointmentSearch v-model="filter" :doctors="doctors" @input="onFilterChange" />

    <div class="mt-5">
      <h2 class="mb-2">Результаты поиска <span class="result-count"></span></h2>

      <div v-if="filter.minDate" class="d-flex align-center mb-5">
        <span>Примененные фильтра:</span>
        <v-chip v-if="filter.minDate" class="ml-2">
          Минимальная дата поиска c: {{ $date(filter.minDate).format("DD.MM.YYYY") }}
        </v-chip>
      </div>

      <v-row v-if="doctors.length" class="result-list">
        <v-col v-for="(item, index) in doctors" :key="index" cols="12">
          <AppointmentCard :item="item" :has-link="doctorShouldHaveLink" />
        </v-col>
      </v-row>

      <div v-if="!doctors.length && filterNotEmpty">По вашему запросу ничего не найдено</div>
      <div v-if="!doctors.length && !filterNotEmpty">На данный момент нет свободных докторов</div>
    </div>
  </v-container>
</template>

<script>
import AppointmentSearch from "./components/AppointmentSearch";
import AppointmentCard from "@/views/pages/appointment/components/AppointmentCard.vue";
import { DoctorsRepository } from "@/modules/doctors/doctors.repository.js";
import { mapMutations } from "vuex";

import PatientHeader from "@/components/PatientHeader";
export default {
  name: "AppointmentList",

  components: {
    AppointmentCard,
    AppointmentSearch,
    PatientHeader,
  },

  data() {
    return {
      doctors: [],
      filter: {
        date: null,
        minDate: this.$route.query.minDate || null,
        clinic: null,
        doctor: null,
        service: null,
        service_method: null,
        specialization: this.$route.query.specialization ? Number(this.$route.query.specialization) : null,
        sort: null,
      },
    };
  },

  computed: {
    doctorShouldHaveLink() {
      return !this.filter.date;
    },

    filterNotEmpty() {
      return Object.keys(this.filter).some(key => this.filter[key] !== null);
    },
  },

  async created() {
    await this.loadDoctors();
  },

  methods: {
    ...mapMutations("appointment", ["SET_DOCTORS"]),

    async loadDoctors() {
      this.doctors = await DoctorsRepository.getAll({
        clinic_id: this.filter.clinic,
        specialization_id: this.filter.specialization,
        date: this.filter.date,
        min_date: this.filter.minDate,
        name: this.filter.doctor,
      });

      this.SET_DOCTORS(this.doctors);
    },

    async onFilterChange() {
      console.log("filter", this.filter);
      await this.loadDoctors();
    },
  },
};
</script>

<style scoped></style>
